import Header from './header';
import IntersectableComponent from './intersectable-component';
import ProductsOverview from './products-overview';
import RegionBanner from './region-banner';
import SectionsMenu from './sections-menu';
import VerticalVideos from './vertical-videos';

export default (di) => {
	di
		.setType({type: Header, name: 'Header', parent: 'IntersectableComponent'})
		.setType({type: ProductsOverview, name: 'ProductsOverview', parent: 'PageComponent', setters: {
				injectHistory: di.lazyGet('navigation/history')
			}
		})
		.setType({type: RegionBanner, name: 'RegionBanner', parent: 'PageComponent'})
		.setType({type: SectionsMenu, name: 'SectionsMenu', parent: 'IntersectableComponent'})
		.setType({type: IntersectableComponent, name: 'IntersectableComponent', parent: 'PageComponent', setters: {
				injectIntersectionObservers: di.lazyGet('dom/intersectionObservers')
			}
		})
		.setType({type: VerticalVideos, name: 'VerticalVideos', parent: 'PageComponent'})
	;
};
